<template>
    <div>
      <router-view></router-view>
    </div>
</template>
<script>
export default {
  name: 'register',
  methods:{}
}
</script>
<style lang="stylus" scoped>
</style>
